// Dropdown
(function () {
  $('.js-dropdown').each(function () {
    let $dropdown = $(this),
        $toggle   = $dropdown.find('.js-dropdown-toggle'),
        $content  = $dropdown.find('.js-dropdown-content');

    $toggle.on('click', function (e) {
      e.preventDefault();
      $dropdown.toggleClass('is-active');
      let active = $dropdown.hasClass('is-active');
      $content.attr('aria-hidden', !active);
    });
  });
})();
